import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance, { axiosFormInstance } from "../../api/axiosInstance";
import { endpoints } from "../../api/endpoints";

export const ShortListedCandidateApi = createAsyncThunk(
  "Client/ShortListedCandidateApi",
  async (userData, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoints.getshortlistedcandidates,
        userData
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const ShortListedCandidateApiSlice = createSlice({
  name: "ShortListedCandidateApiSlice",
  initialState: {
    data: null,
    status: "idle",
    error: null,
  },
  reducers: {
    updateShortlistedCandidates(state, action) {
      const { candidateid, message } = action.payload;
      if (state.data) {
        state.data = state.data.map((candidate) => {
          if (candidate._id?.$oid === candidateid) {
            return {
              ...candidate,
              isdownloaded: true,
              downloadinfo: candidate.downloadinfo
                ? [...candidate.downloadinfo, ...message]
                : [...message],
            };
          }
          return candidate;
        });
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(ShortListedCandidateApi.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(ShortListedCandidateApi.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload.data;
      })
      .addCase(ShortListedCandidateApi.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
export default ShortListedCandidateApiSlice.reducer;
export const { updateShortlistedCandidates } =
  ShortListedCandidateApiSlice.actions;
